import { GENRE_COLORS } from '@app/shared';
import type { Genre } from '@app/shared';

interface Props {
  genre: string | null;
  size?: 'sm' | 'md';
}

export default function GenreChip({ genre, size = 'sm' }: Props) {
  const color = genre && genre in GENRE_COLORS
    ? GENRE_COLORS[genre as Genre]
    : GENRE_COLORS['Unclassified'];

  const style: React.CSSProperties = {
    display: 'inline-block',
    padding: size === 'sm' ? '2px 8px' : '4px 12px',
    borderRadius: 999,
    fontSize: size === 'sm' ? '0.7rem' : '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    background: `${color}25`,
    color,
    border: `1px solid ${color}50`,
  };

  const isUnclassified = !genre || genre === 'Unclassified';
  const label = isUnclassified
    ? <><span style={{ display: 'block', textAlign: 'center' }}>Unclassified</span><span style={{ display: 'block', textAlign: 'center' }}>Genre</span></>
    : genre;

  return <span style={{ ...style, lineHeight: 1.2 }} aria-label={`Genre: ${genre ?? 'Unknown'}`}>{label}</span>;
}
